import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-spring/renderprops'
import { Modal } from '@entrata/portals-common/lib/components'
import { FullscreenLoader } from '../../loaders'
import {
  StyledContent,
  StyledFooterContent,
  StyledModalDiv,
  StyledTitle,
  StyledWrapper,
  portalStyle,
  rootStyle,
} from './atoms'

const PortalModal = props => {
  useEffect(() => {
    props.show && toggleRoot('add')

    return () => {
      toggleRoot('remove')
    }
  }, [])

  useEffect(() => {
    if (document.querySelectorAll('div[id^="modal"]').length <= 1) {
      toggleRoot(props.show ? 'add' : 'remove')
    }
  }, [props.show])

  const handleCancel = () => {
    const { onCancel, onClose } = props
    if (typeof onCancel === 'function') onCancel()
    onClose()
  }

  const toggleRoot = action => {
    document.getElementById('root')?.classList[action](rootStyle)
    document.getElementById('bg-img')?.classList[action]('blur')
  }

  const {
    children,
    footerContent,
    loadingMsg,
    outsideContent,
    show,
    title,
    wrapperClass,
  } = props

  return (
    <Transition
      items={show}
      from={{ opacity: 0, transform: 'translateY(100px)' }}
      enter={{ opacity: 1, transform: 'translateY(0px)' }}
      leave={{ opacity: 0, transform: 'translateY(-200px)' }}
      native
    >
      {show =>
        show &&
        (styles => (
          <Modal
            className={`${portalStyle}${wrapperClass && ' ' + wrapperClass}`}
            onClose={handleCancel}
          >
            {({ containerProps, titleId }) => (
              <Fragment>
                <StyledWrapper style={styles}>
                  <StyledModalDiv {...containerProps}>
                    {title && <StyledTitle id={titleId}>{title}</StyledTitle>}
                    <StyledContent>{children}</StyledContent>
                    {footerContent && (
                      <StyledFooterContent>{footerContent}</StyledFooterContent>
                    )}
                  </StyledModalDiv>
                  {outsideContent}
                </StyledWrapper>
                <FullscreenLoader show={!!loadingMsg}>
                  {loadingMsg}
                </FullscreenLoader>
              </Fragment>
            )}
          </Modal>
        ))
      }
    </Transition>
  )
}

PortalModal.propTypes = {
  /** Content for the modal */
  children: PropTypes.any,
  /** Loading message to be shown while loading content */
  loadingMsg: PropTypes.string,
  /** Hook to the cancel event when needed */
  onCancel: PropTypes.func,
  /** Hook to the close event. Usually provided by ModalControl. */
  onClose: PropTypes.func,
  /** Toggle the visibility of the modal */
  show: PropTypes.bool,
  /** Modal title */
  title: PropTypes.string,
  /** Escape hatch when needing to make minor additions/adjustments to the container div for the modal */
  wrapperClass: PropTypes.string,
  /** Used by ActionModal, contains the elements to be added to the bottom (inside) of modalbox. The content passed to this prop would be placed outside scrollbar. */
  footerContent: PropTypes.any,
  /** Used by ActionModal, contains the elements to be added to the bottom (outside) of modalbox */
  outsideContent: PropTypes.any,
}

PortalModal.defaultProps = {
  wrapperClass: '',
}

export default PortalModal
